import dayjs from "dayjs";
import { ITourOperatorImport } from "../../api/services";
import { IBooleanOption } from "../../types";

export enum ImportPageTab {
    Jimpi = 'jimpi',
    Tui = 'tui' ,
    JimpiDisambiguation = 'jimpi-disambiguation'
}

export enum ImportFilterType {
    jimpi = 'JIMPI',
    tui = 'TUI'
}

export type JimpiImportTableData = ITourOperatorImport;

export type TuiImportTableData = ITourOperatorImport;


// const for interval pooling disambiguation Jimpi
export const INTERVAL_BADGE_DISAMBIGUATION = 150000;

export interface IFormValuesJimpiFilter {
    filename: string,
    importDateFrom: dayjs.Dayjs | null,
    importDateTo: dayjs.Dayjs | null,
    skipped: IBooleanOption | null,
    businessError: IBooleanOption | null,
    technicalError: IBooleanOption | null
} 

export interface IFormValuesTuiFilter {
    filename: string,
    importDateFrom: dayjs.Dayjs | null,
    importDateTo: dayjs.Dayjs | null,
    skipped: IBooleanOption | null,
    businessError: IBooleanOption | null,
    technicalError: IBooleanOption | null
}
